let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("36ctu")).then(() => parcelRequire('kQ3RN'));